import React, { useRef, useCallback, useState, useEffect } from 'react';
import { Table, withStyles } from '@material-ui/core';
import { TableHeader, TableBody, StatusBar } from './components';
import styles from './styles';

const PrintReport = ({ classes, gridApi, setPrintRef, getPrintDataFn }) => {
  const printRef = useRef(null);
  const gridApiRef = useRef(null);
  const [{ ReportHeader, rowData, columns, kpiData }, setPrintData] = useState({
    ReportHeader: <></>,
    rowData: [],
    columns: [],
    kpiData: []
  });

  useEffect(() => {
    gridApiRef.current = gridApi;
  }, [gridApi]);

  // This function that will be called before printing
  const onBeforeGetContent = useCallback(() => {
    return new Promise((resolve) => {
      if (gridApiRef.current && getPrintDataFn) {
        const { ReportHeader, rowData, columns, kpiData } = getPrintDataFn()(gridApiRef.current);
        setPrintData({
          ReportHeader,
          rowData,
          columns,
          kpiData
        });
      }
      resolve();
    });
  }, [getPrintDataFn]);
  
  useEffect(() => {
    setPrintRef?.(printRef, onBeforeGetContent);
  }, [setPrintRef, onBeforeGetContent]);

  return (
    <div className={classes.hideContainer}>
      <div ref={printRef}>
        {ReportHeader}
        <Table className={classes.table}>
          <TableHeader columns={columns} />
          <TableBody columns={columns} rowData={rowData} />
        </Table>
        <StatusBar kpiData={kpiData} />
      </div>
    </div>
  );
};

export default withStyles(styles)(React.memo(PrintReport));
